<wdx-json-editor
    [formControl]="formControl"
    [customInputHandler]="customInputHandler"
    [customOutputHandler]="customOutputHandler"
>
    <div wdxJsonEditorAction>
        <button
            wdxButton
            (click)="openDesigner()"
            [disabled]="!entityId || !targetEntityType"
        >
            {{ DESIGNER_LABEL | translateTokenisedString }}
        </button>
    </div>
</wdx-json-editor>
